import { render, staticRenderFns } from "./CoreSkills.vue?vue&type=template&id=fe79cebe&"
import script from "./CoreSkills.vue?vue&type=script&lang=js&"
export * from "./CoreSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports